import { useEffect } from 'preact/hooks';
import * as S from '../app/state';
import { Home } from './Home';
import { HeroSelect } from './HeroSelect';
import { Squad } from './Squad';
import { Profile } from './Profile';
import { Guild } from './Guild';
import { Settings } from './Settings';
import { Leaderboards } from './Leaderboards';
import { Pets } from './Pets';
import { Vault } from './Vault';
import { HeroBuild } from './HeroBuild';
import { GameScreen } from './Hud';
import { AdminPanel } from './Admin';
import { Shell } from './Shell';
import { ConfirmModal } from './Confirm';
import { IntroModal } from './Intro';
import { t } from '../i18n';
import { game } from '../game/client';
import { Btn, Tooltip, hideTip } from './common';
import { withIntro } from '../app/hints';
import { freeHeroSlot } from '../app/heroes';

function Screen() {
  const s = S.screen.value;
  switch (s) {
    case 'home':
      return <Home />;
    case 'heroes':
      return (
        <HeroSelect
          confirmLabel={t('btn.play')}
          onConfirm={(h) => {
            const slot = freeHeroSlot();
            if (slot < 0) {
              S.showToast(t('label.slotsAllTakenHint'));
              return;
            }
            S.setHero(h);
            S.setSlot(slot);
            withIntro(() => {
              const code = S.pendingRealm.value ?? undefined;
              const ghost = S.pendingAvenge.value ?? undefined;
              S.pendingRealm.value = null;
              S.pendingAvenge.value = null;
              game.join('realm', h, code, ghost, slot);
            });
          }}
          onBack={() => (S.screen.value = 'home')}
        />
      );
    case 'squad':
      return <Squad />;
    case 'profile':
      return <Profile />;
    case 'guild':
      return <Guild />;
    case 'settings':
      return <Settings />;
    case 'pets':
      return <Pets />;
    case 'vault':
      return <Vault />;
    case 'build':
      return <HeroBuild />;
    default:
      return <Leaderboards />;
  }
}

export function App() {
  const s = S.screen.value;
  const inGame = S.inGame.value;
  const overlay = S.menuOpen.value || S.buildOpen.value || S.chatOpen.value || !!S.deathCard.value;
  // a tooltip's owner may vanish or get covered without a mouseleave; drop it on any screen change
  useEffect(() => hideTip(), [s, inGame, overlay]);
  return (
    <>
      {inGame ? (
        <GameScreen />
      ) : (
        <Shell>
          <Screen />
        </Shell>
      )}
      {S.queue.value !== 'idle' && !inGame && (
        <div class="queue">
          <div class="card narrow col center panel pop">
            <h2 class={S.queue.value === 'searching' ? 'pulse' : ''}>{S.queue.value === 'searching' ? t('label.searching') : t('label.found')}</h2>
            {S.queue.value === 'searching' && (
              <Btn
                onClick={() => {
                  game.send({ t: 'duel.cancel' });
                  S.queue.value = 'idle';
                }}
              >
                {t('btn.queueCancel')}
              </Btn>
            )}
          </div>
        </div>
      )}
      <div class={'toasts' + (inGame ? ' ingame' : '')}>
        {S.toasts.value.map((tt) => (
          <div class={'toast' + (tt.kind ? ' ' + tt.kind : '')} key={tt.id}>
            {tt.kind === 'hint' && <span class="glyph">💡</span>}
            {tt.text}
          </div>
        ))}
      </div>
      <ConfirmModal />
      <IntroModal />
      {S.adminOpen.value && <AdminPanel />}
      <Tooltip />
    </>
  );
}
